import { Form } from 'react-bootstrap';

const TextArea = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  placeholder,
  style,
}) => (
  <div className={className}>
    {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
    <div>
      <Form.Control
        name={name}
        id="textArea"
        as="textarea"
        value={value}
        className={inputClassName}
        onChange={onChange}
        placeholder={placeholder}
        style={{ ...style }}
      />
    </div>
  </div>
);

export default TextArea;
